"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdminAddMedicationNamePostRequest = _interopRequireDefault(require("../model/AdminAddMedicationNamePostRequest"));
var _AdminAddMedicationPostRequest = _interopRequireDefault(require("../model/AdminAddMedicationPostRequest"));
var _AdminDeleteMedicationNamePostRequest = _interopRequireDefault(require("../model/AdminDeleteMedicationNamePostRequest"));
var _AdminDeleteMedicationPostRequest = _interopRequireDefault(require("../model/AdminDeleteMedicationPostRequest"));
var _AdminEditMedicationNamePostRequest = _interopRequireDefault(require("../model/AdminEditMedicationNamePostRequest"));
var _AdminEditMedicationPostRequest = _interopRequireDefault(require("../model/AdminEditMedicationPostRequest"));
var _AdminGetMedicationNameTranslationsPostRequest = _interopRequireDefault(require("../model/AdminGetMedicationNameTranslationsPostRequest"));
var _AdminSetMedicationNameTranslationsPostRequest = _interopRequireDefault(require("../model/AdminSetMedicationNameTranslationsPostRequest"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _Language = _interopRequireDefault(require("../model/Language"));
var _MedicationStatisticsObject = _interopRequireDefault(require("../model/MedicationStatisticsObject"));
var _ProgramsUpdateProgramProgressPost200Response = _interopRequireDefault(require("../model/ProgramsUpdateProgramProgressPost200Response"));
var _TranslationValueResponse = _interopRequireDefault(require("../model/TranslationValueResponse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* AdminMedications service.
* @module api/AdminMedicationsApi
* @version 4.0.0
*/
var AdminMedicationsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new AdminMedicationsApi. 
  * @alias module:api/AdminMedicationsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AdminMedicationsApi(apiClient) {
    _classCallCheck(this, AdminMedicationsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * add-medication-name
   * Creates MedicationName (with corresponding name field filled), Medication (with null brand) and MedicationsStatistics record (with zeros). Returns an error on name duplicate or if name is empty or null.
   * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
   * @param {module:model/AdminAddMedicationNamePostRequest} params 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/MedicationStatisticsObject} and HTTP response
   */
  return _createClass(AdminMedicationsApi, [{
    key: "adminAddMedicationNamePostWithHttpInfo",
    value: function adminAddMedicationNamePostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminAddMedicationNamePost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling adminAddMedicationNamePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _MedicationStatisticsObject["default"];
      return this.apiClient.callApi('/admin/add-medication-name', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-medication-name
     * Creates MedicationName (with corresponding name field filled), Medication (with null brand) and MedicationsStatistics record (with zeros). Returns an error on name duplicate or if name is empty or null.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminAddMedicationNamePostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/MedicationStatisticsObject}
     */
  }, {
    key: "adminAddMedicationNamePost",
    value: function adminAddMedicationNamePost(Accept_Language, params) {
      return this.adminAddMedicationNamePostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * add-medication
     * Creates Medication entity with specified medication name link and MedicationsStatistics record (with zeros). Returns an error on brand duplicate or if brand is empty or null. Also an error will be returned if MedicationName doesn't exist or if medication_name_id is empty/absent/null
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminAddMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/MedicationStatisticsObject} and HTTP response
     */
  }, {
    key: "adminAddMedicationPostWithHttpInfo",
    value: function adminAddMedicationPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminAddMedicationPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling adminAddMedicationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _MedicationStatisticsObject["default"];
      return this.apiClient.callApi('/admin/add-medication', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-medication
     * Creates Medication entity with specified medication name link and MedicationsStatistics record (with zeros). Returns an error on brand duplicate or if brand is empty or null. Also an error will be returned if MedicationName doesn't exist or if medication_name_id is empty/absent/null
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminAddMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/MedicationStatisticsObject}
     */
  }, {
    key: "adminAddMedicationPost",
    value: function adminAddMedicationPost(Accept_Language, params) {
      return this.adminAddMedicationPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-medication-name
     * Delete MedicationName and all corresponding Medication entities only if there is no user profiles that uses any of Medication entities. MedicationsStatistics records also will be removed.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminDeleteMedicationNamePostRequest} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminDeleteMedicationNamePostWithHttpInfo",
    value: function adminDeleteMedicationNamePostWithHttpInfo(Accept_Language, opts) {
      opts = opts || {};
      var postBody = opts['params'];
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminDeleteMedicationNamePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin/delete-medication-name', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-medication-name
     * Delete MedicationName and all corresponding Medication entities only if there is no user profiles that uses any of Medication entities. MedicationsStatistics records also will be removed.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminDeleteMedicationNamePostRequest} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminDeleteMedicationNamePost",
    value: function adminDeleteMedicationNamePost(Accept_Language, opts) {
      return this.adminDeleteMedicationNamePostWithHttpInfo(Accept_Language, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-medication
     * Delete medication brand if it is not used in any user profiles. MedicationsStatistics records also will be removed. Generic medication cannot be removed.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminDeleteMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/MedicationStatisticsObject} and HTTP response
     */
  }, {
    key: "adminDeleteMedicationPostWithHttpInfo",
    value: function adminDeleteMedicationPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminDeleteMedicationPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling adminDeleteMedicationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _MedicationStatisticsObject["default"];
      return this.apiClient.callApi('/admin/delete-medication', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-medication
     * Delete medication brand if it is not used in any user profiles. MedicationsStatistics records also will be removed. Generic medication cannot be removed.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminDeleteMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/MedicationStatisticsObject}
     */
  }, {
    key: "adminDeleteMedicationPost",
    value: function adminDeleteMedicationPost(Accept_Language, params) {
      return this.adminDeleteMedicationPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-medication-name
     * Change medication name. Medication names merging is supported. That means if name parameter passed already exists (as another MedicationName entity, let's call it \"target\"), then all related Medication entities connected to edited MedicationName (having specified id) will be updated, so they will be linked to target MedicationName entity. Regardless of merging process happening or not this api call performs mass-update for all affected \"updated\" entities (pain records, user preferences and user profiles).
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminEditMedicationNamePostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/MedicationStatisticsObject} and HTTP response
     */
  }, {
    key: "adminEditMedicationNamePostWithHttpInfo",
    value: function adminEditMedicationNamePostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminEditMedicationNamePost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling adminEditMedicationNamePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _MedicationStatisticsObject["default"];
      return this.apiClient.callApi('/admin/edit-medication-name', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-medication-name
     * Change medication name. Medication names merging is supported. That means if name parameter passed already exists (as another MedicationName entity, let's call it \"target\"), then all related Medication entities connected to edited MedicationName (having specified id) will be updated, so they will be linked to target MedicationName entity. Regardless of merging process happening or not this api call performs mass-update for all affected \"updated\" entities (pain records, user preferences and user profiles).
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminEditMedicationNamePostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/MedicationStatisticsObject}
     */
  }, {
    key: "adminEditMedicationNamePost",
    value: function adminEditMedicationNamePost(Accept_Language, params) {
      return this.adminEditMedicationNamePostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-medication
     * Change medication brand. Medication brands merging is supported.  That means if brand parameter passed already exists and have SAME medication name,  then all Medication related entities are assigned to the target (that has this brand)  Medication and Medication with id specified is simply removed. Brand can be null.  In this case it will be treated like attempt to merge into Generic of specified Medication Name. 'generic' string and all its variations case sensitive variations are forbidden values for brand field.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminEditMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/MedicationStatisticsObject} and HTTP response
     */
  }, {
    key: "adminEditMedicationPostWithHttpInfo",
    value: function adminEditMedicationPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminEditMedicationPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling adminEditMedicationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _MedicationStatisticsObject["default"];
      return this.apiClient.callApi('/admin/edit-medication', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-medication
     * Change medication brand. Medication brands merging is supported.  That means if brand parameter passed already exists and have SAME medication name,  then all Medication related entities are assigned to the target (that has this brand)  Medication and Medication with id specified is simply removed. Brand can be null.  In this case it will be treated like attempt to merge into Generic of specified Medication Name. 'generic' string and all its variations case sensitive variations are forbidden values for brand field.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AdminEditMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/MedicationStatisticsObject}
     */
  }, {
    key: "adminEditMedicationPost",
    value: function adminEditMedicationPost(Accept_Language, params) {
      return this.adminEditMedicationPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * export-medication-name-translations
     * Returns a CSV file containing medication name id, number of users that uses this medication name, original medication name value and translations into all languages
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
  }, {
    key: "adminExportMedicationNameTranslationsGetWithHttpInfo",
    value: function adminExportMedicationNameTranslationsGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/csv', 'application/json'];
      var returnType = File;
      return this.apiClient.callApi('/admin/export-medication-name-translations', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * export-medication-name-translations
     * Returns a CSV file containing medication name id, number of users that uses this medication name, original medication name value and translations into all languages
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
  }, {
    key: "adminExportMedicationNameTranslationsGet",
    value: function adminExportMedicationNameTranslationsGet() {
      return this.adminExportMedicationNameTranslationsGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-medication-name-translations
     * Returns an array of medication name translations
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminGetMedicationNameTranslationsPostRequest} [AdminGetMedicationNameTranslationsPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TranslationValueResponse>} and HTTP response
     */
  }, {
    key: "adminGetMedicationNameTranslationsPostWithHttpInfo",
    value: function adminGetMedicationNameTranslationsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminGetMedicationNameTranslationsPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_TranslationValueResponse["default"]];
      return this.apiClient.callApi('/admin/get-medication-name-translations', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-medication-name-translations
     * Returns an array of medication name translations
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminGetMedicationNameTranslationsPostRequest} opts.AdminGetMedicationNameTranslationsPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TranslationValueResponse>}
     */
  }, {
    key: "adminGetMedicationNameTranslationsPost",
    value: function adminGetMedicationNameTranslationsPost(opts) {
      return this.adminGetMedicationNameTranslationsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-medications-statistics
     * Returns a list of ALL medication name entities with unpacked Medications entities and joined MedicationsStatistics.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/MedicationStatisticsObject>} and HTTP response
     */
  }, {
    key: "adminGetMedicationsStatisticsGetWithHttpInfo",
    value: function adminGetMedicationsStatisticsGetWithHttpInfo(Accept_Language) {
      var postBody = null;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling adminGetMedicationsStatisticsGet");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_MedicationStatisticsObject["default"]];
      return this.apiClient.callApi('/admin/get-medications-statistics', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-medications-statistics
     * Returns a list of ALL medication name entities with unpacked Medications entities and joined MedicationsStatistics.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/MedicationStatisticsObject>}
     */
  }, {
    key: "adminGetMedicationsStatisticsGet",
    value: function adminGetMedicationsStatisticsGet(Accept_Language) {
      return this.adminGetMedicationsStatisticsGetWithHttpInfo(Accept_Language).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * import-medication-name-translations
     * Update medication name translations according to CSV file provided
     * @param {File} file CSV file
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminImportMedicationNameTranslationsPostWithHttpInfo",
    value: function adminImportMedicationNameTranslationsPostWithHttpInfo(file) {
      var postBody = null;
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling adminImportMedicationNameTranslationsPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {
        'file': file
      };
      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin/import-medication-name-translations', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * import-medication-name-translations
     * Update medication name translations according to CSV file provided
     * @param {File} file CSV file
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminImportMedicationNameTranslationsPost",
    value: function adminImportMedicationNameTranslationsPost(file) {
      return this.adminImportMedicationNameTranslationsPostWithHttpInfo(file).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * reindex-medications
     * Remove and recreate all medications Solr index
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminReindexMedicationsPostWithHttpInfo",
    value: function adminReindexMedicationsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin/reindex-medications', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * reindex-medications
     * Remove and recreate all medications Solr index
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminReindexMedicationsPost",
    value: function adminReindexMedicationsPost() {
      return this.adminReindexMedicationsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * set-medication-name-translations
     * Change medication name translations. If translation value is null or emtpy string or missed, then corresponding translation will be removed. If langcode is not supported, translation will be ignored.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminSetMedicationNameTranslationsPostRequest} [AdminSetMedicationNameTranslationsPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminSetMedicationNameTranslationsPostWithHttpInfo",
    value: function adminSetMedicationNameTranslationsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminSetMedicationNameTranslationsPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin/set-medication-name-translations', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * set-medication-name-translations
     * Change medication name translations. If translation value is null or emtpy string or missed, then corresponding translation will be removed. If langcode is not supported, translation will be ignored.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminSetMedicationNameTranslationsPostRequest} opts.AdminSetMedicationNameTranslationsPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminSetMedicationNameTranslationsPost",
    value: function adminSetMedicationNameTranslationsPost(opts) {
      return this.adminSetMedicationNameTranslationsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();